import { render, staticRenderFns } from "./DocumentSimpleNewOrEdit.vue?vue&type=template&id=7c47309a&scoped=true"
import script from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js"
export * from "./DocumentSimpleNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentSimpleNewOrEdit.vue?vue&type=style&index=0&id=7c47309a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c47309a",
  null
  
)

export default component.exports